import React from "react";

const getSetValue = (val) => {
  if (Array.isArray(val)) return val[0] ?? 0;
  if (val && typeof val === "object") return Object.values(val)[0] ?? 0;
  return 0;
};
const getSetValue2 = (val) => {
  if (Array.isArray(val)) return val[1] ?? 0;
  if (val && typeof val === "object") return Object.values(val)[1] ?? 0;
  return 0;
};

const Sets = ({ score, home, away, teamNames, fullScore, positionHome }) => {
  if (!home || !away || !teamNames || !fullScore) return null;

  const l = getSetValue(fullScore);
  const a = getSetValue2(fullScore);
  const homeScore = getSetValue(score);
  const awayScore = getSetValue2(score);

  return (
    <div className="flex justify-center items-center mb-2">
      {positionHome ? (
        <>
          {/* Nome Home */}
          <div className="bg-white shadow-md h-[30px] min-w-[150px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-r-0">
            {teamNames.home?.name}
          </div>
          {/* Placar Home */}
          <div className="h-[40px] w-[50px] flex items-center justify-center bg-blue-600 text-white text-2xl font-bold shadow border-l-0 border-r-0">
            {l}
          </div>
          {/* Separador */}
          <span className="mx-1 text-2xl font-bold text-gray-400">x</span>
          {/* Placar Away */}
          <div className="h-[40px] w-[50px] flex items-center justify-center bg-red-600 text-white text-2xl font-bold shadow border-l-0 border-r-0">
            {a}
          </div>
          {/* Nome Away */}
          <div className="bg-white shadow-md h-[30px] min-w-[150px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-l-0">
            {teamNames.away?.name}
          </div>
        </>
      ) : (
        <>
          {/* Nome Away */}
          <div className="bg-white shadow-md h-[30px] min-w-[150px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-r-0">
            {teamNames.away?.name}
          </div>
          {/* Placar Away */}
          <div className="h-[40px] w-[50px] flex items-center justify-center bg-red-600 text-white text-2xl font-bold shadow border-l-0 border-r-0">
            {a}
          </div>
          {/* Separador */}
          <span className="mx-1 text-2xl font-bold text-gray-400">x</span>
          {/* Placar Home */}
          <div className="h-[40px] w-[50px] flex items-center justify-center bg-blue-600 text-white text-2xl font-bold shadow border-l-0 border-r-0">
            {l}
          </div>
          {/* Nome Home */}
          <div className="bg-white shadow-md h-[30px] min-w-[150px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-l-0">
            {teamNames.home?.name}
          </div>
        </>
      )}
    </div>
  );
};

export default Sets;
